export default {
  title: 'Member Management',
  memberList: 'Member List',
  memberLevel: 'Member Level',
};
